"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_BRUTE_FORCE_KNAPSACK_ITEM_COUNT = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const bankDataProviderKeys = {
    plaid: 'plaid',
    teller: 'teller',
    manualDashboard: 'manualDashboard',
    manualS3Upload: 'manualS3Upload',
};
const regExpFullDateStr = /^\d{4}-\d{2}-\d{2}$/;
const regExpFullDateTimeStr = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
const borrowingBaseContributionAccountTypes = [
    finley_types_1.Bank.BorrowerAccountType.Collections,
    finley_types_1.Bank.BorrowerAccountType.PreFundingAccount,
    finley_types_1.Bank.BorrowerAccountType.PermittedInvestmentsAccount,
    finley_types_1.Bank.BorrowerAccountType.AccountIncludedInBorrowingBase,
];
const cashBalanceFeedContributionAccountTypes = [
    ...borrowingBaseContributionAccountTypes,
    finley_types_1.Bank.BorrowerAccountType.OtherReserveAccount,
];
// manual uploader "uploads" files to local file system when running on development environment.
// we use "~/${DEVELOPMENT_S3_ROOT}/${bucket}/${key}" for such uploads.
const DEVELOPMENT_S3_ROOT = 'local_s3';
const CURRENT_CREDIT_AGREEMENT_DOCUMENT_SCHEMA_VERSION = finley_types_1.CreditAgreement.DomainEntity.CreditAgreementSchemaVersion['1.0'];
/*
const PlaidEnvironments: PlaidEnvironment = {
  prod: 'https://production.plaid.com',
  sandbox: 'https://sandbox.plaid.com',
  development: 'https://development.plaid.com',
};

Update when ready for prod
*/
const plaidEnvForDeployEnv = {
    development: 'sandbox',
    stage: 'sandbox',
    prod: 'prod',
};
const plaidRedirectUriForPlaidEnv = {
    sandbox: undefined,
    development: 'https://app.stage.finleycms.com/settings/integrations',
    prod: 'https://app.finleycms.com/settings/integrations',
};
const plaidAssetReportTransactionDays = 180;
const closeOfBusinessHour = 17;
const MAX_TIMESTAMP = 8640000000000000; // milliseconds
const loanTapeType = {
    masterLoanTape: 'masterLoanTape',
    preassignedLoanTape: 'preassignedLoanTape',
    preassignedMasterLoanTape: 'preassignedMasterLoanTape',
};
// max number of business days in the future that a loan tape is valid for
const maxFutureBusinessDaysReportingDate = 1;
exports.MAX_BRUTE_FORCE_KNAPSACK_ITEM_COUNT = 25;
/**
 * List of reserved markers used to parse identifier of Borrowing Base Pipeline Artifact Instance Identifier
 */
const S3_PATH_MARKER = `#s3Path:`;
const POSTGRES_COLUMN_MARKER = `#column:`;
const POSTGRES_ID_MARKER = `#id:`;
const S3_IDENTIFIER_REGEX = `^${S3_PATH_MARKER}(.*)$`;
const PG_COLUMN_IDENTIFIER_REGEX = `^${POSTGRES_COLUMN_MARKER}(.*)${POSTGRES_ID_MARKER}.*$`;
const PG_ID_IDENTIFIER_REGEX = `^${POSTGRES_COLUMN_MARKER}.*${POSTGRES_ID_MARKER}(.*)$`;
/**
 * Common Styling Attributes
 */
const COLOR_HEX_CODES = {
    RED: '#FF0000',
    YELLOW: '#FFFF00',
    BLUE: '#0000FF',
};
/**
 * @jendevelops MSR-TODO remove once adjusting current liabiities is GA
 *
 * List of borrowers that are allowed to adjust current liabilities (alpha users for deliverables MSR)
 */
const MSR_ALPHA_ORGANIZATION_SLUGS = [
    // round 1
    'acmeCorp',
    'mercury',
    'tripActions',
    'vaya',
    // round 2
    'imprint',
    'foraFinancialWarehouseLlc',
    'nectar',
    'parker',
    'ramp',
];
exports.default = {
    bankDataProviderKeys,
    borrowingBaseContributionAccountTypes,
    cashBalanceFeedContributionAccountTypes,
    closeOfBusinessHour,
    CURRENT_CREDIT_AGREEMENT_DOCUMENT_SCHEMA_VERSION,
    DEVELOPMENT_S3_ROOT,
    maxFutureBusinessDaysReportingDate,
    MAX_TIMESTAMP,
    MAX_BRUTE_FORCE_KNAPSACK_ITEM_COUNT: exports.MAX_BRUTE_FORCE_KNAPSACK_ITEM_COUNT,
    MSR_ALPHA_ORGANIZATION_SLUGS,
    plaidAssetReportTransactionDays,
    plaidEnvForDeployEnv,
    plaidRedirectUriForPlaidEnv,
    loanTapeType,
    regExpFullDateStr,
    regExpFullDateTimeStr,
    S3_PATH_MARKER,
    POSTGRES_COLUMN_MARKER,
    POSTGRES_ID_MARKER,
    COLOR_HEX_CODES,
    S3_IDENTIFIER_REGEX,
    PG_COLUMN_IDENTIFIER_REGEX,
    PG_ID_IDENTIFIER_REGEX,
};
//# sourceMappingURL=consts.js.map